import URLConfig from '@Config/urls/url.config';
import { ChakraComponents } from '@Modules/core/lib/chakra';
import { CustomCard } from '@Shared/components';
import { Link } from 'react-router-dom';

export default function AdminHome() {
  const modules = [
    {
      name: "Gestion des Utilisateurs",
      link: URLConfig.ADMIN.USERS.ROOT,
    },
    {
      name: "Paramètres de base",
      link: URLConfig.ADMIN.BASE_SETTINGS.ROOT,
    },
    {
      name: "Paramètres d'intégration",
      link: URLConfig.ADMIN.INTEGRATION_SETTINGS.ROOT,
    },
    // 'Gestion des Utilisateurs',
    // 'Paramètres de base',
    // "Paramètres d'intégration",
  ];

  const displayModules = () =>
    modules.map(({name, link}) => (
      <ChakraComponents.Box cursor={'pointer'} key={name} mx="2">
        <Link to={link}>
          <CustomCard>
            <ChakraComponents.Box>{name}</ChakraComponents.Box>
          </CustomCard>
        </Link>
      </ChakraComponents.Box>
    ));

  return (
    <>
      <ChakraComponents.Flex>{displayModules()}</ChakraComponents.Flex>
    </>
  );
}
